import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantFeatureService } from '../theme/tenant-feature.service';
import { environment } from 'src/environments/environment';

export const featureGuard: CanActivateFn = (route) => {
  const featureService = inject(TenantFeatureService);
  const router = inject(Router);

  const flag = route.data?.['featureFlag'] as string | undefined;

  if (flag) {
    const envEnabled = environment.featureFlags?.[flag] ?? true;
    if (!envEnabled || !featureService.isEnabled(flag)) {
      return router.createUrlTree(['/dashboard']);
    }
  }

  return true;
};
